import { Link } from 'types/api.types';
import { Time } from 'types/general.types';
import { ProfileCard } from 'types/profile';
import { AudioValidationErrorCodes } from 'app/components/Audio';

export enum AudioStatusType {
  READY_FOR_UPLOAD = 'READY_FOR_UPLOAD',
  PROCESSING = 'PROCESSING',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export enum AudioStatusReasonType {
  READY_FOR_UPLOAD = 'READY_FOR_UPLOAD',
  TRANSCODING = 'TRANSCODING',
  UPLOADING = 'UPLOADING', // Custom type for local FE state management
  RETRYABLE = 'RETRYABLE', // Custom type for local FE state management
  UNSUPPORTED_FILE_TYPE = 'UNSUPPORTED_FILE_TYPE',
  REACHED_MAXIMUM_FILE_SIZE = 'REACHED_MAXIMUM_FILE_SIZE',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export interface _AudioLinks {
  upload: Link;
  play?: Link;
  self: Link;
  waveform?: Link;
}

export interface Audio {
  guid: string;
  created: Time;
  createdBy: {
    guid: string;
    profileCard: ProfileCard;
  };
  isLatestVersion: boolean;
  isPrivate: boolean;
  isMine: boolean;
  isrc?: string;
  isIsrcAllocatedBySession?: boolean;
  originalFilename: string;
  container?: 'midi' | (string & {});
  parent: string;
  remark: string;
  status: AudioStatusType;
  statusReason: AudioStatusReasonType;
  title: string;
  type: string;
  updated: Time;
  duration: number; // ms
  fileSize: number; // bytes
  localFileSize?: number;
  file?: File;
  songTitle?: string;
  validationResult?: {
    isValid: boolean;
    errors: { errorCode: AudioValidationErrorCodes }[];
  };
  _links: _AudioLinks;
}

export interface AudioTypeOption {
  key: string;
  name: string;
}

export interface AudioTypesDDL {
  [key: string]: AudioTypeOption;
}
